import { DeskSigner } from 'client/api/backend/schemas';

export function formatSignersNames(signers?: DeskSigner[]) {
  if (!signers) return undefined;

  return signers.map(signer => signer.name ?? '');
}
